"use strict";

var _createClass = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/createClass.js").default;
var _classCallCheck = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/classCallCheck.js").default;
var _inherits = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/inherits.js").default;
var _createSuper = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/createSuper.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShortCSSPropertyValidator = void 0;
var _GenericPropertyValidator = require("./GenericPropertyValidator");
var ShortCSSPropertyValidator = /*#__PURE__*/function (_GenericPropertyValid) {
  _inherits(ShortCSSPropertyValidator, _GenericPropertyValid);
  var _super = _createSuper(ShortCSSPropertyValidator);
  function ShortCSSPropertyValidator(params) {
    _classCallCheck(this, ShortCSSPropertyValidator);
    return _super.call(this, params, true);
  }
  /**
   * Expand a CSS shorthand property to its longhand equivalent.
   *
   * @param value
   */
  return _createClass(ShortCSSPropertyValidator);
}(_GenericPropertyValidator.GenericCSSPropertyValidator);
exports.ShortCSSPropertyValidator = ShortCSSPropertyValidator;